/**
 * A metric is also the navigation: clicking it swaps the body for the screen
 * that answers it. Active carries the brick underline and eyebrow. The
 * explanation of the number is a hover title, not a line under it — the
 * band reads as three numbers.
 */
import React from "react";

import { eyebrowSx, lbb } from "../utils/tokens";

const Metric: React.FC<{
	title: string;
	value: string;
	/** What the number means, shown on hover. */
	sub: string;
	color: string;
	active: boolean;
	onClick: () => void;
}> = ({ title, value, sub, color, active, onClick }) => (
	<button
		type="button"
		onClick={onClick}
		title={sub}
		style={{
			display: "flex",
			alignItems: "baseline",
			gap: 8,
			textAlign: "left",
			background: "none",
			border: "none",
			borderBottom: `2px solid ${active ? lbb.brick : "transparent"}`,
			padding: "2px 0 4px",
			cursor: "pointer",
			font: "inherit",
		}}
	>
		<div style={{ ...eyebrowSx, color: active ? lbb.brick : lbb.ink60 }}>{title}</div>
		<div
			style={{
				fontFamily: lbb.fontBrand,
				fontSize: 22,
				fontWeight: 700,
				letterSpacing: "-0.03em",
				lineHeight: 1,
				color,
			}}
		>
			{value}
		</div>
	</button>
);

/** The hairline between two metrics. */
export const MetricDivider: React.FC = () => <div style={{ width: 1, background: lbb.navy20 }} />;

export default Metric;
